// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2565":"9eb584a4","7169":"9eb584a4","8688":"27dd0431"}[chunkId] + ".chunk.css";
};